<template>
  <div>
    <div v-for="status in sorted" :key="status.id">
      <p><span class="has-text-weight-semibold">{{ status.dynamic_status.name }}:</span> {{ status.value }}</p>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    activeStatuses: {
      type: Array,
      default: () => ({}),
    },
    typeId: {
      type: Number,
      default: () => ({}),
    },
  },
  computed: {
    sorted(){
      return this.filtered.sort((a, b) => {
        const nameA = a.dynamic_status.name.toUpperCase();
        const nameB = b.dynamic_status.name.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });
    },
    filtered(){
      return this.activeStatuses.filter(status => status.dynamic_status.asset_type_id === this.typeId)
    }
  }
}
</script>